import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { DropArrowIcon } from "../Icons";
import SaleBg from "../../images/sale/salebg.jpg";
import MobileSaleBg from "../../images/sale/mobile-salebg.jpg";
// import SaleTitleGif from "../../images/sale/sale-title.gif";

const SaleLocation = styled.div`
  position: relative;
`;
const SaleWrap = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;
  max-width: 100%;
  width: 100%;
  transition: all 0.5s;
  transform: translateY(100%);
  box-shadow: 0px -2px 20px rgba(0, 0, 0, 0.4);
  background-color: #0B0355;
  background-image: ${(props) => props.mbg};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 100%;
  bottom: 36px;
  @media (min-width: 768px) {
    bottom: 0;
  }
  @media (min-width: 992px) {
    background-image: ${(props) => props.bg};
  }
  &.show {
    transform: translateY(0);
    .arrow {
      svg {
        transform: scaleY(1);
      }
    }
  }
`;

const SaleArrow = styled.div`
  position: absolute;
  right: 84px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  width: 38px;
  height: 38px;
  background: #0B0355;
  border-radius: 10px 10px 0 0;
  bottom: 100%;
  svg {
    fill: #fff;
    transform: scaleY(-1);
    transition: all 0.4s ease-in-out;
    height: 12px;
    width: 12px;
  }
`;

const SaleContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
`;
const SaleInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 80px;
  padding-right:60px;
  @media (min-width: 992px) {
    min-height: 100px;
    padding-right:0;
  }
  @media (min-width: 1600px) {
    min-height: 100px;
  }
`;

const SaleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
  width: 100%;  
  padding: 10px;
  margin: 0 -5px;
  @media (min-width: 768px) {
    margin: 0 -10px;
  }
  @media (min-width: 992px) {
    max-width: 920px;
    margin: 0 -15px;
    padding: 5px 10px;
  }
  @media (min-width: 1200px) {
    max-width: 100%;
    margin: 0 -20px;
  }
  @media (min-width: 1400px) {
    margin: 0 -30px;
  }
  @media (min-width: 1600px) {
    margin: 0 -60px;
  }
`;
const SaleColumn = styled.div`
    padding: 0 5px;
  @media (min-width: 768px) {
    padding: 0 10px;
  }
  @media (min-width: 992px) {
    padding: 0 15px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 60px;
  }
`;

//CSS for Desktop
const SaleForDesktop = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
const SaleTitle = styled.div`
    padding: 0 15px;
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 60px;
  }
  .gatsby-image-wrapper, img {
    margin: 0 auto;
    width: 90%;
    @media (min-width: 1400px) {
      width: 100%;
    }
  }
`;
const SaleOffter = styled.div`
  padding: 0 15px;
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 60px;
  }
  .gatsby-image-wrapper {
    margin: 0 auto;
    width: 90%;
    @media (min-width: 1400px) {
      width: 100%;
    }
  }
`;
const SaleContent = styled.div`
 padding: 0 15px;
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 60px;
  }
  .gatsby-image-wrapper {
    margin: 0 auto;
    width: 90%;
    @media (min-width: 1400px) {
      width: 100%;
    }
  }
`;

const ButtonToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: none;
  @media (min-width: 768px) {
    display: flex;
  }

  .btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 24px;
    border: 1px solid transparent;
    overflow: inherit;   

    > .icon {
      display: none;
      align-items: center;
      justify-content: center;
      padding:0;
      @media (min-width: 768px) {
        display: flex;
        border-radius: 50%;
        background: #fff;
        width: 36px;
        height: 36px;
      }
      @media (min-width: 992px) {
        width: 42px;
        height: 42px;
      }
      @media (min-width: 1200px) {       
        width: 48px;
        height: 48px;
      }      
      + .text {
        padding: 4px 8px;
        @media (min-width: 768px) {
          padding: 6px 12px;
        }
        @media (min-width: 992px) {
          padding: 8px 16px;
        }
        @media (min-width: 1200px) {
          padding: 10px 20px;
        }
      }
    }
    > .text {
      font-weight: 700;     
      font-size: 14px;
      line-height: 20px;      
     
      @media (min-width: 576px) {
        font-size: 16px;
        line-height: 22px;
      }
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 24px;
        padding: 6px 12px;
      }
      @media (min-width: 992px) {
        font-size: 20px;
        line-height: 26px;
        padding: 8px 16px;
      }
      @media (min-width: 1200px) {
        font-size: 22px;
        line-height: 28px;
        padding: 10px 20px;
      }
    }
  }
  .btn-white {
    background-color: #A11AD3;
    border-color: #A11AD3;
    color: #fff;
    &:after, &:before{
      display:none;
    }
    &:hover{
      background-color:#000;
      color: #fff;
    }
  }
  &.d-md-none {
    @media (min-width: 768px) {
      display: none;
    }
  }
  &.d-md-block {
    display: none;
    @media (min-width: 768px) {
      display: flex;
    }
  }
`;

const CallText = styled.div`
  position:relative;
  display:none;    
  flex-wrap: wrap;
  justify-content:center;
  color:#fff;
  margin:10px auto 0 auto;
  font-weight:700;
  @media (min-width: 768px) {      
    display:flex;    
    font-size: 10px;
    line-height:16px;
  }
  @media (min-width: 992px) {   
    font-size: 12px;
    line-height:18px;
  }
  @media (min-width: 1400px) {   
    font-size: 14px;
    line-height:20px;
  }
`

//CSS for Mobile
const SaleForMobile = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 768px) {
    display: none;
  }
`;
const SaleTitleMobile = styled.div`
  margin: 0 auto;
  .gatsby-image-wrapper, img {
    width: 100%;
    margin: 0 auto;
    max-width: 140px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
const SaleOffterMobile = styled.div`    
  margin: 0 auto;
  .gatsby-image-wrapper {
    width: 100%;
    margin: 0 auto;
    max-width: 150px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;

const SaleBlackFriday = ({ location }) => {
  const [showHelp, setShowHelp] = useState(true);
  // const prevScrollPosRef = useRef(0);
  const stickyClosedRef = useRef("");

  const ToggleHelp = () => {
    stickyClosedRef.current = !showHelp ? "closed" : "";
    const res = showHelp ? "show" : "hide";
    localStorage.setItem("SaleBlackFriday", res);
    setShowHelp(!showHelp);
  };

  useEffect(() => {
    // const handleScroll = () => {
    //   const currentScrollPos = document.documentElement.scrollTop;

    //   if (currentScrollPos > prevScrollPosRef.current) {
    //     setShowHelp(true);
    //   } else if (
    //     currentScrollPos === 0 &&
    //     stickyClosedRef.current !== "closed"
    //   ) {
    //     setShowHelp(false);
    //   }

    //   prevScrollPosRef.current = currentScrollPos;
    // };

    if (typeof window !== `undefined`) {
      const cd = localStorage.getItem("SaleBlackFriday");
      if (!cd || cd === "show") {
        setShowHelp(false);
        stickyClosedRef.current = ""
      } else {
        setShowHelp(true);
        stickyClosedRef.current = "closed"
      }
    }

    // window.addEventListener("scroll", handleScroll);

    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
  }, []);

  return (
    <SaleLocation location={location}>
      <SaleWrap
        className={showHelp ? "" : "show"}
        bg={`url(${SaleBg})`}
        mbg={`url(${MobileSaleBg})`}
      >
        <SaleArrow className="arrow" onClick={ToggleHelp}>
          <DropArrowIcon />
        </SaleArrow>
        <SaleContainer>
          <SaleInner>
            <SaleRow>
              <SaleColumn>
                {/* Desktop */}
                <SaleForDesktop>
                  <SaleTitle>
                    {/* <img src={SaleTitleGif} alt="EMB Metal Buildings" /> */}
                    <StaticImage
                      src="../../images/sale/sale-title.png"
                      placeholder="blurred"
                      alt="EMB Metal Buildings"
                    />
                  </SaleTitle>
                  <SaleOffter>
                    <StaticImage
                      src="../../images/sale/offer.png"
                      placeholder="blurred"
                      alt="EMB Metal Buildings"
                      />
                  </SaleOffter>
                  <SaleContent>
                    <StaticImage
                    src="../../images/sale/usp.png"
                    placeholder="blurred"
                    alt="EMB Metal Buildings"
                    />
                  </SaleContent>
                </SaleForDesktop>

                {/* Mobile */}
                <SaleForMobile>
                  <SaleTitleMobile>
                    {/* <img src={SaleTitleGif} alt="EMB Metal Buildings" /> */}
                    <StaticImage
                      src="../../images/sale/sale-title-mobile.png"
                      placeholder="blurred"
                      alt="EMB Metal Buildings"
                    />
                  </SaleTitleMobile>
                  <ButtonToolbar className="d-md-none">
                    <a
                      href="tel:2085721441"
                      aria-label="phone number"
                      className="btn btn-white"
                    >
                      <span className="icon">
                        {" "}
                        <StaticImage
                          src="../../images/sale/call.png"
                          placeholder="blurred"
                          alt="EMB Metal Buildings"
                        />
                      </span>
                      <span className="text">(208) 572-1441</span>
                    </a>
                  </ButtonToolbar>
                </SaleForMobile>
              </SaleColumn>

              <SaleColumn>
                <SaleOffterMobile>
                  <StaticImage
                    src="../../images/sale/offer-mobile.png"
                    placeholder="blurred"
                    alt="EMB Metal Buildings"
                  />
                </SaleOffterMobile>
                <ButtonToolbar className="d-md-block">
                  <a
                    href="tel:2085721441"
                    aria-label="phone number"
                    className="btn btn-white"
                  >
                    <span className="icon">
                      {" "}
                      <StaticImage
                        src="../../images/sale/call.png"
                        placeholder="blurred"
                        alt="EMB Metal Buildings"
                      />
                    </span>
                    <span className="text">(208) 572-1441</span>
                  </a>
                </ButtonToolbar>
                <CallText>*Offer Valid in Select States Only!</CallText>
                {/* <SaleHelpText>Limited Time Offer!</SaleHelpText> */}
              </SaleColumn>
            </SaleRow>
          </SaleInner>
        </SaleContainer>
      </SaleWrap>
    </SaleLocation>
  );
};
export default SaleBlackFriday;
